import React from 'react';
import PropTypes from 'prop-types';
import { createFragmentContainer, graphql } from 'react-relay';
import get from 'lodash.get';
import ContextComponent from '../ContextComponent';

import SocialIcon from '../SocialIcon/SocialIcon';
import PinterestIcon from 'dibs-vg/dist/react/pinterest';

import pinterestUtils from '../../utils/social/pinterest';

import PinterestConnectBoardModal from './PinterestConnectBoardModal';
import PinterestConnectAccountsModal from './ConnectAccountsModal';

import {
    connectAccounts as connectAccountsCopy,
    connectBoards as connectBoardsCopy,
    tracking,
} from './pinterest.json';

class PinterestPinIcon extends ContextComponent {
    constructor(props) {
        super(props);
        this.pin = this.pin.bind(this);

        this.state = {
            connectAccountsModalIsOpen: !!props.connectAccountsModalIsOpen,
            connectBoardModalIsOpen: false,
        };
    }

    componentWillReceiveProps(nextProps) {
        if (!this.props.connectAccountsModalIsOpen && nextProps.connectAccountsModalIsOpen) {
            this.setState({ connectAccountsModalIsOpen: true });
        }
    }

    onPin() {
        const { onPin } = this.props;

        if (typeof onPin === 'function') {
            onPin();
        }
    }

    pin() {
        const pinterestWindow = pinterestUtils.openWindow();
        const { url, media, description, connectAccounts, viewer, user } = this.props;

        if (connectAccounts) {
            const socialNetwork = get(viewer, 'socialNetworks.0');
            const userSocialNetwork = get(user, 'socialNetworks.0', null);
            pinterestUtils.showConnectModalAfterPinAdded({
                tracking: tracking.connectModalPinClicked,
                pinterestWindow,
                url,
                media,
                description,
                socialNetwork,
                userSocialNetwork,
                onSuccess: () => {
                    this.setState({ connectAccountsModalIsOpen: true });
                },
            });
        } else {
            pinterestUtils.pin({ pinterestWindow, url, media, description });
        }

        this.onPin();
    }

    render() {
        const { connectAccountsModalIsOpen, connectBoardModalIsOpen } = this.state;
        const { iconType, viewer, user, item } = this.props;
        const userId = get(user, 'serviceId');
        const userSocialNetwork = get(user, 'socialNetworks.0', null);
        const clientId = get(viewer, 'socialNetworks.0.parameters.clientId');

        return (
            <span>
                <SocialIcon
                    onClick={this.pin}
                    Icon={PinterestIcon}
                    iconName="pinterest"
                    iconType={iconType}
                    data-tn="pinterest"
                />

                <PinterestConnectAccountsModal
                    clientId={clientId}
                    copy={connectAccountsCopy}
                    tracking={tracking}
                    userId={userId}
                    isOpen={connectAccountsModalIsOpen}
                    item={item}
                    onClose={() => {
                        this.setState({ connectAccountsModalIsOpen: false });
                    }}
                    onSuccess={() => {
                        this.setState({ connectBoardModalIsOpen: true });
                    }}
                />

                <PinterestConnectBoardModal
                    isOpen={connectBoardModalIsOpen}
                    onClose={() => {
                        this.setState({ connectBoardModalIsOpen: false });
                    }}
                    userId={userId}
                    userSocialNetwork={userSocialNetwork}
                    copy={connectBoardsCopy}
                    tracking={tracking}
                />
            </span>
        );
    }
}

PinterestPinIcon.displayName = 'PinterestPinIcon';

PinterestPinIcon.propTypes = {
    connectAccountsModalIsOpen: PropTypes.bool,
    url: PropTypes.string.isRequired,
    media: PropTypes.string.isRequired,
    description: PropTypes.string.isRequired,
    connectAccounts: PropTypes.bool,
    iconType: PropTypes.string,
    onPin: PropTypes.func,
    item: PropTypes.object,
};

PinterestPinIcon.defaultProps = {
    url: '',
    media: '',
    description: '',
};

export default createFragmentContainer(PinterestPinIcon, {
    viewer: graphql`
        fragment PinterestPinIcon_viewer on Viewer {
            socialNetworks(socialNetworkNames: PINTEREST) {
                serviceId
                parameters {
                    clientId
                }
            }
        }
    `,
    user: graphql`
        fragment PinterestPinIcon_user on User {
            serviceId
            socialNetworks(socialNetworkNames: [PINTEREST]) {
                ... on PinterestSocialNetwork {
                    ...PinterestConnectBoardModal_userSocialNetwork
                    status
                }
            }
        }
    `,
});



// WEBPACK FOOTER //
// ./assets/js/global/components/Pinterest/PinterestPinIcon.jsx